module.exports = __webpack_public_path__ + "img/cinema.73c4a2db.jpg";